import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';

import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';
import TrangBonboz from './bonboz/Trang.vue';
import TheBonboz from './bonboz/The.vue';
import CamXucBonboz from './bonboz/CamXuc.vue';
import QuangCaoBonboz from './bonboz/QuangCao.vue';
// BonBoZ: trang Tuong tac - luot cham vao hoi thoai, chia khach moi/cu.
import TuongTacBonboz from './bonboz/TuongTac.vue';
// BonBoZ: trang Tong dai — chua noi kenh thoai, moi so la 0 nhung truy van that.
import TongDaiBonboz from './bonboz/TongDai.vue';
// BonBoZ: hai trang cuoi cua phan Thong ke — danh gia CSAT va hang doi sao luu.
import DanhGiaBonboz from './bonboz/DanhGia.vue';
import SaoLuuBonboz from './bonboz/SaoLuu.vue';
// BonBoZ: ban thay the cho `AgentReportsIndex.vue`. File upstream giu nguyen,
// chi doi mot dong import nay - xem dau file NhanVien.vue.
import NhanVienBonboz from './bonboz/NhanVien.vue';
// BonBoZ: thong bao day co toi duoc nhan vien khong — gui / may nhan / bam.
import PushReportBonboz from './bonboz/PushReport.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: NhanVienBonboz,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TheBonboz,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        // BonBoZ: duong dan giu nguyen 'conversation' de link cu khong chet,
        // nhung noi dung la thong ke THEO TRANG - xem dau file Trang.vue.
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: TrangBonboz,
        },
        // Pheu da nam trong trang Trang. Giu route nay tro cung cho de link cu
        // (bookmark, tin nhan noi bo) khong chet 404.
        {
          path: 'pheu',
          name: 'bonboz_pheu_theo_trang',
          meta,
          component: TrangBonboz,
        },
        {
          path: 'tuong-tac',
          name: 'bonboz_tuong_tac',
          meta,
          component: TuongTacBonboz,
        },
        {
          path: 'tong-dai',
          name: 'bonboz_tong_dai',
          meta,
          component: TongDaiBonboz,
        },
        {
          path: 'danh-gia',
          name: 'bonboz_danh_gia',
          meta,
          component: DanhGiaBonboz,
        },
        {
          path: 'sao-luu',
          name: 'bonboz_sao_luu',
          meta,
          component: SaoLuuBonboz,
        },
        {
          path: 'thong-bao-day',
          name: 'bonboz_push_report',
          meta,
          component: PushReportBonboz,
        },
        // BonBoZ: thong ke quang cao — nguon khach tu Meta ads.
        {
          path: 'quang-cao',
          name: 'bonboz_quang_cao',
          meta,
          component: QuangCaoBonboz,
        },
        // BonBoZ: cam xuc khach hang — nhan tu cot messages.sentiment.
        {
          path: 'cam-xuc',
          name: 'bonboz_cam_xuc',
          meta,
          component: CamXucBonboz,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
      ],
    },
  ],
};
